export default (function (_ref) {
  var colors = _ref.colors;
  return {
    '@global': {
      "input[type='number']::-webkit-outer-spin-button, input[type='number']::-webkit-inner-spin-button": {
        WebkitAppearance: 'none',
        margin: 0
      }
    },
    wrapper: {
      '&:after': {
        content: "''",
        clear: 'both',
        display: 'table'
      }
    },
    inputWrapper: {
      height: '40px',
      position: 'relative',
      backgroundColor: colors.white,
      marginBottom: '12px',
      float: 'right',
      width: '100px'
    },
    input: {
      color: 'hsl(0, 0%, 30%)',
      fontWeight: 300,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'hsl(0, 0%, 80%)',
      outline: 'none',
      WebkitAppearance: 'none',
      borderRadius: 0,
      transition: 'border-color .2s',
      width: '100%',
      height: '100%',
      float: 'left',
      background: 'none',
      padding: '4px 10px',
      position: 'relative',
      zIndex: '2',
      appearance: 'textfield',
      ':focus': {
        borderColor: colors.primary
      }
    },
    input__withUnit: {
      padding: '4px 40px 4px 10px'
    },
    input__withUnitLeft: {
      padding: '4px 10px 4px 40px'
    },
    valueWrapper: {
      height: '40px',
      marginBottom: '12px',
      float: 'right'
    },
    value: {
      display: 'inline-block',
      color: colors.white,
      lineHeight: '40px',
      fontSize: '40px',
      fontWeight: 500
    },
    valueUnit: {
      display: 'inline-block',
      color: colors.primaryLighter,
      lineHeight: '40px',
      marginRight: 0,
      marginLeft: '5px'
    },
    valueUnit__rtl: {
      marginLeft: 0,
      marginRight: '5px'
    },
    label: {
      display: 'block',
      float: 'left',
      fontSize: '19px',
      color: colors.white,
      lineHeight: '40px',
      fontWeight: 400
    },
    unit: {
      height: '40px',
      lineHeight: '40px',
      color: 'gray',
      padding: '0 10px',
      textAlign: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      pointerEvents: 'none'
    },
    unit__rtl: {
      right: 'auto',
      left: 0
    }
  };
});